import React, { useEffect } from 'react';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { documentService, windowService } from '../../../utils/window.utils';
import Carousel from './carousel';
import './style.scss';

const GalleryCarousel = ({ slides }): JSX.Element => {
  useEffect(() => {
    const viewHeight = windowService().innerHeight;
    documentService().documentElement.style.setProperty('--vh-100', `${viewHeight}px`);
    const resize = (): void => {
      const resizedViewHeight = windowService().innerHeight;
      documentService().documentElement.style.setProperty('--vh-100', `${resizedViewHeight}px`);
    };
    windowService().addEventListener('resize', resize);
    return (): void => {
      windowService().removeEventListener('resize', resize);
    };
  }, []);

  return (
    <section className={'fullscreen-media'}>
      <Carousel slides={slides} />
    </section>
  );
};

export default React.memo(GalleryCarousel);
